"use strict";

import { CommonXhrErrorHandler } from "webroot/static/src/common/js/common.error";
import { DialogsService, LongWorkService } from "../providers/uikit.dialogs";

declare var window: any;

let staticInstance: BaseRepository = null;

let showLongWork = () => {
	if (staticInstance && staticInstance.$longWork) {
		staticInstance.$longWork.show();
	}
}

let closeLongWork = () => {
	if (staticInstance && staticInstance.$longWork) {
		staticInstance.$longWork.close();
	}
}

export class BaseRepository {
	public raw: this;

	/*@ngInject*/
	constructor(protected $http, protected $dialogs: DialogsService, public $longWork: LongWorkService) {
		staticInstance = this;
		this.raw = this.createRawRepository(this)
	}

	createRawRepository<Repository extends BaseRepository>(repository: Repository): Repository {
		const rawCopy = Object.create(repository) as Repository;

		Object.getOwnPropertyNames(this).forEach(prop => {
			if (prop !== 'raw') {
				rawCopy[prop] = this[prop];
			}
		});

		rawCopy.handleResponse = rawCopy.handleResponse;
		rawCopy.handleError = (response) => {
			return Promise.reject(response);
		};
		return rawCopy;
	}

	handleResponse = (response) => {
		if (response.status == 204)
			return null;
		return response.data;
	}

	handleResponseSimple(response) {
		return response.data;
	}

	handleError = (response) => {
		closeLongWork();

		const errInformer = (message) => staticInstance.$dialogs.error(message);
		const messageInformer = (message) => staticInstance.$dialogs.message(message);
		return new CommonXhrErrorHandler(errInformer, messageInformer).handleErrorResponse(response);
	}

	get(url: string, options?: any) {
		if (window.appContext.environment === "dev" || window.appContext.environment === "development") {
			console.log("url:", url);
			console.log("options:", options);
		}
		showLongWork()
		return this.$http.get(url, options).then(this.handleResponse, this.handleError).finally(() => closeLongWork());
	}

	post(url: string, options?: any) {
		if (window.appContext.environment === "dev" || window.appContext.environment === "development") {
			console.log("url:", url);
			console.log("options:", options);
		}
		showLongWork()
		return this.$http.post(url, options).then(this.handleResponse, this.handleError).finally(() => closeLongWork());
	}
}